/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect } from "react";
import {
    PayPalScriptProvider,
    PayPalButtons,
    usePayPalScriptReducer,
} from "@paypal/react-paypal-js";
import { paypalConfig } from "../../../configs/Paypal";
import { IBookingPayment } from "../../../utils/PaymentInterfaces";
import { ConfirmationReservationService } from "../../Reservation/services/ConfirmationReservationService";
import { ReservationContext } from "../../../contexts/AppContext";
import { useHistory } from "react-router-dom";
import { EPaymentMethod } from "../../../utils/enum/PaymentMethod";
import { ETransactionType } from "../../../utils/enum";
import { currencyAccepted } from "../../../utils/App";

// This values are the props in the UI
const amount = "2";
// const currency = "USD";
const style = { layout: "vertical" };

// Custom component to wrap the PayPalButtons and handle currency changes
const confirmReserService = new ConfirmationReservationService();
const ButtonWrapper = ({
    currency,
    showSpinner,
    paymentData,
    setLoadingPage,
    paidByCredit,
}: {
    currency: string;
    showSpinner: boolean;
    paymentData: IBookingPayment;
    setLoadingPage: (val: boolean) => void;
    paidByCredit?: number;
}) => {
    // usePayPalScriptReducer can be use only inside children of PayPalScriptProviders
    // This is the main reason to wrap the PayPalButtons in a new component
    const [{ options, isPending }, dispatch] = usePayPalScriptReducer();
    const reservationContext = useContext(ReservationContext);
    const { reservation } = reservationContext;
    const history = useHistory();

    //console.group('[PaypalBookingPaymentButton]');
    /*console.log('[PaypalBookingPaymentButton] - received props:', {
        rawData: paymentData
    }); 

    console.log('[ButtonWrapper] Initial props:', { 
        currency, 
        showSpinner, 
        paymentData: JSON.parse(JSON.stringify(paymentData)), 
        paidByCredit 
    });  */

    useEffect(() => {
        dispatch({
            type: "resetOptions",
            value: {
                ...options,
                currency: currency,
            },
        });
    }, [currency, showSpinner, paymentData]);

    return (
        <>
            {showSpinner && isPending && <div className="spinner" />}
            <PayPalButtons
                style={style as any}
                disabled={false}
                forceReRender={[amount, currency, style]}
                fundingSource={undefined}
                createOrder={(data, actions) => {
                    console.log('[PayPalButtons] createOrder triggered with paymentData:', 
                        JSON.parse(JSON.stringify(paymentData)));
                    return confirmReserService
                        .createPayment(paymentData)
                        .then((response) => {
                            //console.log('PayPal orderId record:', response);
                            if (response.success) {
                                //console.log('[createPayment] Order created with ID:', response.data.orderId);
                                return response.data.orderId;
                            }
                        })
                        .catch((error) => {
                            console.log("Paypal buttons error", error);
                        });
                    // return actions.order
                    //     .create({
                    //         purchase_units: [
                    //             {
                    //                 amount: {
                    //                     currency_code: currency,
                    //                     value: amount,
                    //                 },
                    //             },
                    //         ],
                    //     })
                    //     .then((orderId) => {
                    //         // Your code here after create the order
                    //         console.log('orderId', orderId)
                    //         return orderId;
                    //     });
                }}
                onApprove={function (data, actions) {
                    //console.log('[PayPalButtons] Payment approved, data:', data);

                     if (!actions.order) {
                        console.error('PayPal actions.order is undefined');
                        setLoadingPage(false);
                        return Promise.reject(new Error('PayPal order actions unavailable'));
                    }
                    return actions.order
                        .capture()
                        .then(function (responseOrder) {
                            // Your code here after capture the order
                            //console.log('[PayPalButtons] Order captured:', responseOrder);
                            setLoadingPage(true);
                            if (responseOrder.status === "COMPLETED") {
                                  //console.log('[PayPalButtons] Payment COMPLETED, saving reservation...');
                                 //console.log('[PayPalButtons] Payment COMPLETED, reservation Data:', reservation);
                                confirmReserService
                                    .saveReservation(reservation)
                                    .then((response) => {
                                         //console.log('[saveReservation] Success:', response);
                                        const transactionData = {
                                            method: EPaymentMethod.Paypal,
                                            billingToken: data.facilitatorAccessToken,
                                            facilitatorAccessToken: data.facilitatorAccessToken || "", // Ensure string
                                            orderID: responseOrder.id,
                                            payerID: responseOrder.payer.payer_id || "", // Ensure string
                                            paymentID: null,
                                            link: responseOrder.links[0]?.href || "", // Ensure string
                                            paymentEmail: responseOrder.payer.email_address || "", // Ensure string
                                            reservation: response.data,
                                            announceAd: null,
                                            amount: paymentData.transaction.amount.total,
                                            type: ETransactionType.Sending,
                                            amountCredit: paidByCredit || 0, // Ensure number
                                        };
                                        
                                         //console.log('[saveTransaction] Preparing data:', transactionData);
                                        
                                        confirmReserService
                                            .saveTransaction(transactionData)
                                            .then((resp) => {
                                                 //console.log('[saveTransaction] Response:', resp);
                                                if (resp.success) {
                                                     //console.log('[Navigation] Redirecting to success page');
                                                    history.push(
                                                        `/booking/payment-done-successfully-${resp.data._id}`
                                                    );
                                                    confirmReserService
                                                        .sendReservationNotification(
                                                            resp.data
                                                                .reservation
                                                        )
                                                        .catch((error) => {
                                                            console.log(error);
                                                            setLoadingPage(
                                                                false
                                                            );
                                                        });
                                                }
                                                setLoadingPage(false);
                                            })
                                            .catch((err) => {
                                                setLoadingPage(false);
                                            });
                                    })
                                    .catch((error) => {
                                        setLoadingPage(false);
                                    });
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                            setLoadingPage(false);
                        });
                }}
                onCancel={function (data, actions) {
                   //console.log('[PayPalButtons] Payment cancelled by user');
                }}
            />
        </>
    );
};

export function PaypalBookingPaymentButtons({
    paymentData,
    setLoadingPage,
    paidByCredit,
}: {
    paymentData: IBookingPayment;
    setLoadingPage: (val: boolean) => void;
    paidByCredit?: number;
}) {
    const currencyExpected = currencyAccepted.includes(
        paymentData.transaction.items?.booking?.announce?.devise.toUpperCase()
    )
        ? paymentData.transaction.items.booking.announce.devise.toUpperCase()
        : "EUR";
    return (
        <div style={{ maxWidth: "750px", minHeight: "200px" }}>
            <PayPalScriptProvider
                options={{
                    "client-id": paypalConfig.cliendID,
                    components: "buttons",
                    currency: currencyExpected,
                }}
            >
                <ButtonWrapper
                    currency={currencyExpected}
                    showSpinner={false}
                    paymentData={paymentData}
                    setLoadingPage={setLoadingPage}
                    paidByCredit={paidByCredit}
                />
            </PayPalScriptProvider>
        </div>
    );
}
